import axios from '../axios'

/* 
 * 考试中心
 */
//查询
export const getList = (params) => {
  return axios({
      url: '/exam/center/list',
      method: 'get',
      params
  })
}
//查询学校班级
export const getClassListApi = (params) => {
  return axios({
      url: `/common/school`,
      method: 'get',
      params
  })
}
//开始考试
export const startExamApi = data => {
  return axios({
      url: '/exam/center/start',
      method: 'post',
      data
  })
}
//结束考试
export const stopExamApi = data => {
  return axios({
      url: '/exam/center/stop',
      method: 'put',
      data
  })
}

//查询历史记录列表
export const getHistoryList = (params) => {
  return axios({
      url: '/exam/center/history/list',
      method: 'get',
      params
  })
}
//成绩列表
export const getRecordListApi = (params) => {
  return axios({
      url: '/exam/center/score/list',
      method: 'get',
      params
  })
}


// WEBPACK FOOTER //
// ./src/http/api/examCenter.js